/**
 * @name ClearFilters
 * @description Componente común de botón para borrar los filtros aplicados
 * @author Ricardo Guerra
 */

import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import styled from 'styled-components';

import { Flex, MUI, Unicons, Typography } from '@tycommon/styles';

const ClearFilters = ({ onClear }) => {
  return (
    <Styled.ButtonLink onClick={(event) => {
      onClear();
      event.stopPropagation();
    }}
    >
      <Flex.Row alignItems="flex-end">
        <Unicons.Sync size="20" style={{ marginRight: '8px' }} />
        <Typography.Span color="blueDark">{i18n.t('GenericMessages.clearFilters')}</Typography.Span>
      </Flex.Row>
    </Styled.ButtonLink>
  );
};

ClearFilters.propTypes = {
  // Función que se ejecuta para resetar los filtros.
  onClear: PropTypes.func.isRequired
};

// *************************************
// STYLED COMPONENTS
// *************************************

const Styled = {};

Styled.ButtonLink = styled(MUI.ButtonLink)`
  position: absolute;
  top: 0px;
  left: 128px;
  z-index: 1;
  &.MuiButton-root {
    height: 40px;
    width: fit-content;
    margin: 8px;
    padding: 0 16px 0 16px;
    white-space: nowrap;
    border-radius: 6px;
    border: 1px solid ${(props) => props.theme.colors.greyLight};
    background-color: ${(props) => props.theme.colors.white};
    &:hover {
      border: 1px solid ${(props) => props.theme.colors.blueDarkAlpha};
      background-color: ${(props) => props.theme.colors.blueDarkAlpha};
    }
  }
`;

export default ClearFilters;